import { render, staticRenderFns } from "./CnpjBulklogPersistView.vue?vue&type=template&id=46f22790"
import script from "./CnpjBulklogPersistView.vue?vue&type=script&lang=ts"
export * from "./CnpjBulklogPersistView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports